import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.5 20H21v-6.75l.22.22a.751.751 0 0 0 1.06-1.064L13.06 3.19a1.5 1.5 0 0 0-2.12 0l-9.22 9.218a.75.75 0 1 0 1.06 1.06L3 13.25V20H1.5a.75.75 0 0 0 0 1.5h21a.75.75 0 1 0 0-1.5m-18-8.25 7.5-7.5 7.5 7.5V20H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V20H4.5zm9 8.25h-3v-4.5h3z"
    }, null, -1)
  ])))
}
export default { render: render }